import Ride from 'common/types/Ride';
import {createFetchListActions} from 'common/actions/utils';
import UserApi from 'common/api/UserApi';

export const UPDATE_RIDE = 'UPDATE_RIDE';

export function updateRide(ride) {
  return {type: UPDATE_RIDE, ride};
}

export const UPDATE_RIDE_REQUEST = 'UPDATE_RIDE_REQUEST';

export function updateRideRequest(rideRequest) {
  return {type: UPDATE_RIDE_REQUEST, rideRequest};
}

export const CLEAR_RIDE_REQUEST = 'CLEAR_RIDE_REQUEST';

export function clearRideRequest() {
  return {type: CLEAR_RIDE_REQUEST};
}

export const REQUEST_CANCEL_RIDE = 'REQUEST_CANCEL_RIDE';

export function requestCancelRide() {
  return {type: REQUEST_CANCEL_RIDE};
}

export const RECEIVE_CANCEL_RIDE = 'RECEIVE_CANCEL_RIDE';

export function receiveCancelRide(ride) {
  return {type: RECEIVE_CANCEL_RIDE, ride};
}

export const RECEIVE_CANCEL_RIDE_ERROR = 'RECEIVE_CANCEL_RIDE_ERROR';

export function receiveCancelRideError(error) {
  return {type: RECEIVE_CANCEL_RIDE_ERROR, error};
}

export const CLEAR_CANCEL_RIDE_ERROR = 'CLEAR_CANCEL_RIDE_ERROR';

export function clearCancelRideError() {
  return {type: CLEAR_CANCEL_RIDE_ERROR};
}

export function createRide(
  agencyId,
  serviceId,
  rideRequest,
  rideRequestDirections,
) {
  return (dispatch, _getState, {api}) => {
    const {
      pickup,
      dropoff,
      origin,
      destination,
      originDistance,
      destinationDistance,
    } = rideRequestDirections;
    const rideOrigin = originDistance >= 1 // 1 meter
      ? {position: {latitude: origin.position.lat, longitude: origin.position.lng}}
      : null;
    if (rideOrigin) rideOrigin.name = origin.name;
    const rideDestination = destinationDistance >= 1 // 1 meter
      ? {position: {latitude: destination.position.lat, longitude: destination.position.lng}}
      : null;
    if (rideDestination) rideDestination.name = destination.name;
    const ride = {
      pickup: {
        address: pickup.name,
        position: {
          latitude: pickup.position.lat,
          longitude: pickup.position.lng,
        },
        timestamp: rideRequest.pickupDateTime ? rideRequest.pickupDateTime.format() : null,
      },
      dropoff: {
        address: dropoff.name,
        position: {
          latitude: dropoff.position.lat,
          longitude: dropoff.position.lng,
        },
      },
      origin: rideOrigin,
      payment: rideRequest.payment,
      destination: rideDestination,
      capacity: rideRequest.capacity,
      wheelchair: rideRequest.wheelchair,
      bicycle: rideRequest.bicycle,
      service_id: serviceId,
      source: 'rider_web',
    };
    dispatch(updateRideRequest({isFetching: true}));
    return api.createRide(agencyId, ride).then(response => {
      switch (response.status) {
        case 200:
          return response.json().then(json => {
            const ride = new Ride(json);
            dispatch(updateRideRequest({isConfirmed: true, isFetching: false}));
            dispatch(updateRide(ride));
            dispatch(clearRideRequest());
            return ride;
          });
        case 400:
          return response
            .json()
            .then(json => dispatch(updateRideRequest({
              errors: json.errors,
              isFetching: false,
            })));
        case 409:
          return response.json()
            .then(json => dispatch(updateRideRequest({
              errors: [
                {description: json.description},
              ],
              isFetching: false,
            })));
        default:
          throw response;
      }
    });
  };
}

export function cancelRide(agencyId, rideId) {
  return (dispatch, getState, {api}) => {
    dispatch(requestCancelRide());
    return api.cancelRide(agencyId, rideId)
      .then(response => {
        switch (response.status) {
          case 200:
            return response.json()
              .then((json) => {
                dispatch(receiveCancelRide(new Ride(json)));
              });
          case 400:
            return response.json()
              .then(json =>
                dispatch(receiveCancelRideError(json.description))
              );
          default:
            throw response;
        }
      });
  };
}

export const {
  requestRides,
  receiveRides,
  fetchRides,
  fetchRidesIfNeeded,
} = createFetchListActions({
  name: 'ride',
  DataType: Ride,
  api: new UserApi(),
  idProp: 'rideId',
});



// WEBPACK FOOTER //
// ./src/ondemand/actions/ride.js